import { index } from './utils';
import translations from '../app/translations/gb';

index(translations);
